// Minimum characters typed before search autocomplete fires. Below this we
// show recent searches instead of fetching suggestions, and the "no results"
// empty state is suppressed (we haven't searched yet).
//
// Single source of truth so every search surface — global search
// (useUnifiedSearch / NavbarSearch / MobileSearchOverlay), the Mixpedia
// per-tab search (DJPalSearchBar / MobileTypedSearchOverlay), and the Set
// Planner add-track search (WhatsNextTab) — stays in lockstep. This value has
// changed before and was inconsistent across surfaces; keep it here.
//
// Note: this gates AUTOCOMPLETE only. Explicit submit (Enter / "see all
// results") intentionally stays permissive so short full-text searches still
// work.
export const MIN_SEARCH_CHARS = 3;
